var _path, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompleted = function SvgCompleted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2526 0.840838C11.6504 0.393322 12.3496 0.393322 12.7474 0.840838L14.4661 2.77432C14.7065 3.04477 15.0742 3.16425 15.4276 3.08676L17.9545 2.53273C18.5394 2.4045 19.1051 2.8155 19.1639 3.41136L19.4178 5.98578C19.4533 6.34588 19.6806 6.65869 20.0121 6.80375L22.382 7.8408C22.9306 8.08083 23.1466 8.74585 22.844 9.26246L21.5362 11.4945C21.3533 11.8067 21.3533 12.1933 21.5362 12.5055L22.844 14.7375C23.1466 15.2542 22.9306 15.9192 22.382 16.1592L20.0121 17.1963C19.6806 17.3413 19.4533 17.6541 19.4178 18.0142L19.1639 20.5886C19.1051 21.1845 18.5394 21.5955 17.9545 21.4673L15.4276 20.9132C15.0742 20.8358 14.7065 20.9552 14.4661 21.2257L12.7474 23.1592C12.3496 23.6067 11.6504 23.6067 11.2526 23.1592L9.53394 21.2257C9.29355 20.9552 8.92581 20.8358 8.57237 20.9132L6.04548 21.4673C5.46061 21.5955 4.89492 21.1845 4.83614 20.5886L4.5822 18.0142C4.54668 17.6541 4.31941 17.3413 3.98791 17.1963L1.61797 16.1592C1.06943 15.9192 0.853355 15.2542 1.15604 14.7375L2.4638 12.5055C2.64673 12.1933 2.64673 11.8067 2.4638 11.4945L1.15604 9.26246C0.853355 8.74585 1.06943 8.08083 1.61797 7.8408L3.98791 6.80375C4.31941 6.65869 4.54668 6.34588 4.5822 5.98578L4.83614 3.41136C4.89492 2.8155 5.46061 2.4045 6.04548 2.53273L8.57237 3.08676C8.92581 3.16425 9.29355 3.04477 9.53394 2.77432L11.2526 0.840838Z",
    fill: "#86FF73"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11897_44228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 12.6667L9.9987 15.3333L16.6654 8.66666",
    stroke: "#1D2529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11897_44228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompleted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/completed.20660564.svg";
export { ForwardRef as ReactComponent };